import { getAdvancingSessionProgress } from "advancing/utils";
import { ProgressRing } from "components/Atoms/ProgressRing";
import React from "react";
import { getShowAppointmentHeaderTexts } from "shared/utils/purpleHeaderUtils";
import { EventHeaderLayout } from "./EventHeaderLayout";

interface AdvancingSessionHeaderProps {
  advancingSession: server.dto.AdvancingSession
  href?: string
}

export const AdvancingSessionHeader = ({ advancingSession, href }: AdvancingSessionHeaderProps) => {
  const { show } = advancingSession;
  const texts = getShowAppointmentHeaderTexts(show);

  return <EventHeaderLayout
    tourName={texts.tourName}
    title={texts.title}
    subtitle={texts.subtitle}
    location={texts.location}
    dateTime={show.dateTime}
    attendees={[]}
    artistName={show.artistName}
    locked={show.isLocked}
    href={href}
    rightColumn={<ProgressRing percentage={getAdvancingSessionProgress(advancingSession)} />}
  />;
};
